export function extensionIcon(filename) {
  if (!filename) {
    return 'ri-file-fill';
  }

  var ext = filename?.split('.').pop() ?? '';
  ext = ext.toUpperCase();
  if (ext === 'PDF') {
    return 'ri-file-pdf-fill';
  } else if (
    ext === 'XSL' ||
    ext === 'XSLX' ||
    ext === 'CSV' ||
    ext === 'XLSM' ||
    ext === 'XLSB' ||
    ext === 'XLTX' ||
    ext === 'XLTM' ||
    ext === 'XLSX' ||
    ext === 'XLS'
  ) {
    return 'ri-file-excel-fill';
  } else if (ext === 'PNG' || ext === 'JPG' || ext === 'JPEG') {
    return 'ri-image-2-fill';
  } else if (ext === 'DOCX' || ext === 'DOC') {
    return 'ri-file-word-fill';
  } else if (ext === 'PPT' || ext === 'PPTX') {
    return 'ri-file-ppt-fill';
  } else if (ext === 'ZIP' || ext === 'RAR') {
    return 'ri-zip-fill';
  } else if (ext === 'MP4' || ext === 'AVI' || ext === 'MKV' || ext === 'MOV' || ext === 'WMV' || ext === 'FLV' || ext === 'WEBM') {
    return 'ri-vidicon-fill';
  } else {
    return 'ri-file-fill';
  }
}
